import { BrowserModule } from '@angular/platform-browser';
import { NgModule, LOCALE_ID } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { DataTablesModule } from 'angular-datatables';


import es from '@angular/common/locales/es';
import { DatePipe, registerLocaleData } from '@angular/common';
registerLocaleData(es);

// PAQUETES
import { NgxLoadingModule } from 'ngx-loading';
import { NgxPageScrollModule } from 'ngx-page-scroll';
import { NgSelectModule } from '@ng-select/ng-select';
import { CKEditorModule } from 'ng2-ckeditor';
import { Ng5SliderModule } from 'ng5-slider';
import { TreeModule } from 'ng2-tree';
import { ChecklistModule} from 'angular-checklist';
import { FlatpickrModule } from 'angularx-flatpickr';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';

// RUTAS
import {APP_ROUTING} from './rutas/rutas';



// COMPONENTES
import { AppComponent } from './app.component';

import { PublicComponent } from './rutas/public/public.component';
import { HomeComponent } from './components/public/home/home.component';

import { FooterPublicComponent } from './components/layouts/public/footer/footer.component';
import { NavbarPublicComponent } from './components/layouts/public/navbar/navbar.component';

import { CoguiComponent } from './components/public/Cogui/cogui/cogui.component';
import { PQRSComponent } from './components/public/pqrs/pqrs.component';
import { QueEsCoguiComponent } from './components/public/Cogui/Fundamentos/que-es-cogui/que-es-cogui.component';
import { NuestrosSimbolosComponent } from './components/public/Cogui/Fundamentos/nuestros-simbolos/nuestros-simbolos.component';
import { ManualDeCalidadComponent } from './components/public/Cogui/Fundamentos/manual-de-calidad/manual-de-calidad.component';
import { ContactenosComponent } from './components/public/Cogui/contactenos/contactenos.component';



// tslint:disable-next-line:max-line-length
import { PoliticaYObjetivosDeCalidadComponent } from './components/public/Cogui/Fundamentos/politica-yobjetivos-de-calidad/politica-yobjetivos-de-calidad.component';
import { GestionDelCambioComponent } from './components/public/Cogui/Fundamentos/gestion-del-cambio/gestion-del-cambio.component';
import { MapaDeProcesosComponent } from './components/public/Cogui/Fundamentos/mapa-de-procesos/mapa-de-procesos.component';
import { MapaDeRiesgosComponent } from './components/public/Cogui/Fundamentos/mapa-de-riesgos/mapa-de-riesgos.component';
import { ModelosAplicablesComponent } from './components/public/Cogui/Fundamentos/modelos-aplicables/modelos-aplicables.component';
// tslint:disable-next-line:max-line-length
import { NormogramaInstitucionalComponent } from './components/public/Cogui/Fundamentos/normograma-institucional/normograma-institucional.component';
// tslint:disable-next-line:max-line-length
import { PoliticaDeIntegridadYBuenGobiernoComponent } from './components/public/Cogui/Fundamentos/politica-de-integridad-y-buen-gobierno/politica-de-integridad-y-buen-gobierno.component';
// tslint:disable-next-line:max-line-length
import { CertificadoDeCalidadNTCGComponent } from './components/public/Cogui/Fundamentos/certificado-de-calidad-ntcg/certificado-de-calidad-ntcg.component';
// tslint:disable-next-line:max-line-length
import { CertificadoDeCalidadISOComponent } from './components/public/Cogui/Fundamentos/certificado-de-calidad-iso/certificado-de-calidad-iso.component';
import { BarraSubNavegacionComponent } from './components/public/Cogui/Fundamentos/barra-sub-navegacion/barra-sub-navegacion.component';

// Servicios
// import { UserService } from './servicios/user.service';
// import { TranslateService } from './servicios/translate.service';

// Pipes
import { TranslatePipe } from './pipes/translate.pipe';
import { DonseguroPipe } from './pipes/donseguro.pipe';
import { filterNorma } from './pipes/filterNorma.pipe';

import { FilterColumnPipe } from './pipes/filter-column.pipe';



import { Loading } from './Class/Loading';

import { DocumentosComponent } from './components/public/Cogui/documentos/documentos.component';

import { TramitesYServiciosComponent } from './components/public/tramites-yservicios/tramites-yservicios.component';
import { TramitesCiudadanoComponent } from './components/public/tramites-yservicios/tramites-ciudadano/tramites-ciudadano.component';

import { DetalleTramiteCComponent } from './components/public/tramites-yservicios/detalle-tramite-c/detalle-tramite-c.component';
import { CertificadoCalidadNTCComponent } from './components/public/Cogui/Fundamentos/certificado-calidad-ntc/certificado-calidad-ntc.component';

import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';

import { PqrsConsultarComponent } from './components/public/pqrs/consultar-pqrs/pqrs-consultar.component';
import { TramiteConsultaComponent } from './components/public/tramites-yservicios/tramite-consulta/tramite-consulta.component';
import { SistemaCoguiComponent } from './components/public/Cogui/sistema-cogui/sistema-cogui.component';
import { SensibilizacionYCapacitacionComponent } from './components/public/Cogui/paso-a-paso/sensibilizacion-y-capacitacion/sensibilizacion-y-capacitacion.component';
import { LogrosComponent } from './components/public/Cogui/paso-a-paso/logros/logros.component';
import { BarraDeNavegacionLateralComponent } from './components/public/Cogui/paso-a-paso/barra-de-navegacion-lateral/barra-de-navegacion-lateral.component';
import { CertificadosCalidadComponent } from './components/public/Cogui/Fundamentos/certificados-calidad/certificados-calidad.component';
import { AdminComponent } from './rutas/admin/admin.component';
import { DashboardComponent } from './components/admin/dashboard/dashboard.component';
import { ConsultasPqrsComponent } from './components/admin/consultas-pqrs/consultas-pqrs.component';
import { FooterAdminComponent } from './components/layouts/admin/footer/footer.component';
import { NavbarAdminComponent } from './components/layouts/admin/navbar/navbar.component';
import { LoginComponent } from './components/login/login.component';
import { ListadoPQRSComponent } from './components/admin/PQRS/listado-pqrs/listado-pqrs.component';
import { LoginPublicComponent } from './components/login/login-public/login-public.component';
import { SubMenuSolicitudDocumentoComponent } from './components/admin/dashboard/sub-menu-solicitud-documento/sub-menu-solicitud-documento.component';
import { PqrsIntegranteEntidadComponent } from './components/admin/pqrs-integrante-entidad/pqrs-integrante-entidad.component';
import { PqrsFacultadesComponent } from './components/admin/pqrs-facultades/pqrs-facultades.component';
import { SubMenuConsultaComponent } from './components/admin/dashboard/sub-menu-consulta/sub-menu-consulta.component';
import { CrearSolicitudComponent } from './components/admin/gestion-documental/crear-solicitud/crear-solicitud.component';
import { RevisionSolicitudComponent } from './components/admin/gestion-documental/revision-solicitud/revision-solicitud.component';
import { ListadoSolicitudesComponent } from './components/admin/gestion-documental/listado-solicitudes/listado-solicitudes.component';
import { ListadoDocumentosComponent } from './components/admin/gestion-documental/listado-documentos/listado-documentos.component';
import { NuevaVersionDocumentoComponent } from './components/admin/gestion-documental/nueva-version-documento/nueva-version-documento.component';
import { VersionesDocumentoComponent } from './components/admin/gestion-documental/versiones-documento/versiones-documento.component';
import { CrearDocumentosComponent } from './components/admin/gestion-documental/crear-editar-documentos/crear-documentos.component';
import { ListadoComponent } from './components/admin/personas/listado/listado.component';
import { IntegrantesProgramasComponent } from './components/admin/integrantes-programas/integrantes-programas.component';
import { IntergrantesFacultadesComponent } from './components/admin/integrantes-facultades/integrantes-facultades.component';
import { IntegrantesUnidadesComponent } from './components/admin/integrantes-unidades/integrantes-unidades.component';
import { SubMenuNormaExternaComponent } from './components/admin/dashboard/sub-menu-norma-externa/sub-menu-norma-externa.component';
import { SubMenuNormaInternaComponent } from './components/admin/dashboard/sub-menu-norma-interna/sub-menu-norma-interna.component';
import { SubMenuTramitesComponent } from './components/admin/dashboard/sub-menu-tramites/sub-menu-tramites.component';
import { SubMenuAcuerdosComponent } from './components/admin/dashboard/sub-menu-norma-interna/sub-menu-acuerdos/sub-menu-acuerdos.component';
import { SubMenuCircularesComponent } from './components/admin/dashboard/sub-menu-norma-interna/sub-menu-circulares/sub-menu-circulares.component';
import { ListadoNormaComponent } from './components/admin/normatividad/listado-norma/listado-norma.component';
import { CrearNComponent } from './components/admin/normatividad/crear/crear.component';
import { EditarNComponent } from './components/admin/normatividad/editar/editar.component';
import { GestionUnidadesComponent } from './components/admin/unidades-organizativas/gestion-unidades/gestion-unidades.component';
import { ListadoTramitesComponent } from './components/admin/tramites/listado-tramites/listado-tramites.component';
import { DetalleTramiteComponent } from './components/admin/tramites/detalle-tramite/detalle-tramite.component';
import { SolicitudTramiteComponent } from './components/admin/tramites/solicitud/solicitud.component';
import { TipoTramitesComponent } from './components/admin/tramites/tipo-tramites/tipo-tramites.component';
import { DetalleTramitePbComponent } from './components/admin/tramites/detalle-tramite-pb/detalle-tramite-pb.component';
import { CrearTramitesComponent } from './components/admin/tramites/crear/crear.component';
import { DetalleNormaAComponent } from './components/admin/normatividad/detalle/detalle.component';
import { EditarDetalleComponent } from './components/admin/normatividad/editar-detalle/editar-detalle.component';
import { PreliminarComponent } from './components/admin/normatividad/preliminar/preliminar.component';
import { SuscritosComponent } from './components/admin/normatividad/suscritos/suscritos.component';
import { FacultadesComponent } from './components/admin/facultades/facultades.component';
import { EncuestaPqrsComponent } from './components/public/encuesta-pqrs/encuesta-pqrs.component';
import { HistorialPqrsComponent } from './components/admin/PQRS/historial-pqrs/historial-pqrs.component';
import { PqrsFacultadesHistorialComponent } from './components/admin/pqrs-facultades/pqrs-facultades-historial/pqrs-facultades-historial.component';
import { ConsultasEncuestasComponent } from './components/admin/consultas-encuestas/consultas-encuestas.component';






@NgModule({
  declarations: [
    AppComponent,
    AdminComponent,
    PublicComponent,
    HomeComponent,

    FooterPublicComponent,
    NavbarPublicComponent,
    FooterAdminComponent,
    NavbarAdminComponent,
    TranslatePipe,
    DashboardComponent,
    DonseguroPipe,
    
    CoguiComponent,
    PQRSComponent,
    QueEsCoguiComponent,
    NuestrosSimbolosComponent,
    ManualDeCalidadComponent,
    PoliticaYObjetivosDeCalidadComponent,
    GestionDelCambioComponent,
    MapaDeProcesosComponent,
    MapaDeRiesgosComponent,
    ModelosAplicablesComponent,
    NormogramaInstitucionalComponent,
    PoliticaDeIntegridadYBuenGobiernoComponent,
    CertificadoDeCalidadNTCGComponent,
    CertificadoDeCalidadISOComponent,
    BarraSubNavegacionComponent,
    
    ContactenosComponent,
    
    filterNorma,    
    FilterColumnPipe,
    DocumentosComponent,
    TramitesYServiciosComponent,
    TramitesCiudadanoComponent,
    DetalleTramiteCComponent,
    CertificadoCalidadNTCComponent,
    PqrsConsultarComponent,
    TramiteConsultaComponent,
    SistemaCoguiComponent,
    SensibilizacionYCapacitacionComponent,
    LogrosComponent,
    BarraDeNavegacionLateralComponent,
    CertificadosCalidadComponent,
    ConsultasPqrsComponent,
    LoginComponent,
    ListadoPQRSComponent,
    LoginPublicComponent,
    SubMenuSolicitudDocumentoComponent,
    PqrsIntegranteEntidadComponent,
    PqrsFacultadesComponent,
    SubMenuConsultaComponent,
    CrearSolicitudComponent,
    RevisionSolicitudComponent,
    ListadoSolicitudesComponent,
    ListadoDocumentosComponent,
    NuevaVersionDocumentoComponent,
    VersionesDocumentoComponent,
    CrearDocumentosComponent,
    ListadoComponent,
    IntegrantesProgramasComponent,
    IntergrantesFacultadesComponent,
    IntegrantesUnidadesComponent,
    SubMenuNormaExternaComponent,
    SubMenuNormaInternaComponent,
    SubMenuTramitesComponent,
    SubMenuAcuerdosComponent,
    SubMenuCircularesComponent, 
    ListadoNormaComponent,
    CrearNComponent,
    EditarNComponent,
    GestionUnidadesComponent,
    ListadoTramitesComponent,
    DetalleTramiteComponent,
    SolicitudTramiteComponent,
    TipoTramitesComponent,
    DetalleTramitePbComponent,
    CrearTramitesComponent,
    DetalleNormaAComponent,
    EditarDetalleComponent,
    PreliminarComponent,
    SuscritosComponent,
    FacultadesComponent,
    EncuestaPqrsComponent,
    HistorialPqrsComponent,
    PqrsFacultadesHistorialComponent,
    ConsultasEncuestasComponent
  ],
  imports: [
    BrowserModule,
    APP_ROUTING,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    NgxLoadingModule.forRoot({}),
    CKEditorModule,
    NgxPageScrollModule,
    NgSelectModule,
    DataTablesModule,
    Ng5SliderModule,
    TreeModule,
    ChecklistModule,

    CalendarModule.forRoot({ provide: DateAdapter, useFactory: adapterFactory }),
    BrowserAnimationsModule,
    NgbModalModule,
    FormsModule,
    FlatpickrModule.forRoot()
  ],

  providers: [
    { provide: LOCALE_ID, useValue: 'es-ES' },
    
    Loading,
    DatePipe
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
